/* eslint-disable @typescript-eslint/indent */
/* eslint-disable max-lines */
import { createContext } from 'react';
import type { TimeWheelContextT } from './useConfigTimePickerCTX.js';

export const defaultTimePickerContext = {} as TimeWheelContextT;
/** Context for cross component communication */
export const TimeWheelContext = createContext<TimeWheelContextT>(defaultTimePickerContext);

export default TimeWheelContext;
